module.exports = __webpack_public_path__ + "82e7d8f28a8ed7e640ab2a35a4b9c0d9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-17.png
// module id = 1767
// module chunks = 0